import {omit} from 'lodash';

import {denormFn, normFn} from '../normalizerSupport';
import * as SectionNormalize from '../section/normalize';
import type * as Types from './types';

export const normalize = normFn<Types.SweepPageObjSchema>(
  'sweep-view',
  (whole, ctx) => {
    return {
      ...omit(whole, 'section'),
      sectionRef: SectionNormalize.normalize(whole.section, ctx),
    };
  }
);

export const denormalize = denormFn<Types.SweepPageObjSchema>((part, ctx) => ({
  ...omit(part, 'sectionRef'),
  section: SectionNormalize.denormalize(part.sectionRef, ctx),
}));
